import { action } from 'typesafe-actions';
import {
  AttendanceInterface,
  UserMessageInteface,
  UserInterface,
  AttendanceTypes,
  TagsInterface,
  TagInterface,
  ReplyInterface,
  OfficeHoursInterface,
  AttendantInterface,
  WebhookInterface,
  AttendantChartInterface,
  AttendanceHistoryInterface,
  HeatmapInterface,
  ConversationReplyInterface,
  RatingListInterface,
  NumberOfMessagesInterface,
  WordCountInterface,
  HumanAndChatbotChartDataInterface,
} from './types';

// Init websocket
export const initWebsocketChannel = (payload: { data: any }) =>
  action(AttendanceTypes.INIT_WEBSOCKET_CHANNEL, payload);
export const closeWebsocketChannel = () =>
  action(AttendanceTypes.CLOSE_WEBSOCKET_CHANNEL);

// Get Attendance message
export const getMessagesRequest = (payload: {
  Room: string;
  conversationStatus: number;
}) => action(AttendanceTypes.GET_MESSAGES_REQUEST, payload);
export const getMessagesSuccess = (payload: {
  MessageData: AttendanceInterface;
}) => action(AttendanceTypes.GET_MESSAGES_SUCCESS, payload);
export const getMessagesFailure = () =>
  action(AttendanceTypes.GET_MESSAGES_FAILURE);

// List Opened Users
export const listOpenedUsersRequest = (payload: {
  Room: string;
  Limit: string;
  UpdatedAt: string;
  ConversationStatus: number;
}) => action(AttendanceTypes.LIST_OPENED_USERS_REQUEST, payload);
export const listOpenedUsersSuccess = (payload: {
  Users: UserInterface[];
  firstRequest: boolean;
}) => action(AttendanceTypes.LIST_OPENED_USERS_SUCCESS, payload);
export const listOpenedUsersFailure = () =>
  action(AttendanceTypes.LIST_OPENED_USERS_FAILURE);

// List Closed Users
export const listClosedUsersRequest = (payload: {
  Room: string;
  Limit: string;
  UpdatedAt: string;
  ConversationStatus: number;
}) => action(AttendanceTypes.LIST_CLOSED_USERS_REQUEST, payload);
export const listClosedUsersSuccess = (payload: {
  Users: UserInterface[];
  firstRequest: boolean;
}) => action(AttendanceTypes.LIST_CLOSED_USERS_SUCCESS, payload);
export const listClosedUsersFailure = () =>
  action(AttendanceTypes.LIST_CLOSED_USERS_FAILURE);

// List Chatbot Users
export const listChatbotUsersRequest = (payload: {
  Room: string;
  Limit: string;
  UpdatedAt: string;
  ConversationStatus: number;
}) => action(AttendanceTypes.LIST_CHATBOT_USERS_REQUEST, payload);
export const listChatbotUsersSuccess = (payload: {
  Users: UserInterface[];
  firstRequest: boolean;
}) => action(AttendanceTypes.LIST_CHATBOT_USERS_SUCCESS, payload);
export const listChatbotUsersFailure = () =>
  action(AttendanceTypes.LIST_CHATBOT_USERS_FAILURE);

// Filter users by name
export const filterUsersByNameRequest = (payload: {
  username: string;
  conversationStatus: number;
  _limit: number;
}) => action(AttendanceTypes.FILTER_USERS_BY_NAME_REQUEST, payload);
export const filterUsersByNameSuccess = (payload: { Users: UserInterface[] }) =>
  action(AttendanceTypes.FILTER_USERS_BY_NAME_SUCCESS, payload);
export const filterUsersByNameFailure = () =>
  action(AttendanceTypes.FILTER_USERS_BY_NAME_FAILURE);

// Filter users by message
export const filterUsersByMessageRequest = (payload: {
  message: string;
  conversationStatus: number;
}) => action(AttendanceTypes.FILTER_USERS_BY_MESSAGE_REQUEST, payload);
export const filterUsersByMessageSuccess = (payload: {
  Users: UserInterface[];
}) => action(AttendanceTypes.FILTER_USERS_BY_MESSAGE_SUCCESS, payload);
export const filterUsersByMessageFailure = () =>
  action(AttendanceTypes.FILTER_USERS_BY_MESSAGE_FAILURE);

// Filter users by tag
export const filterUsersByTagRequest = (payload: {
  tagId: string;
  conversationStatus: number;
}) => action(AttendanceTypes.FILTER_USERS_BY_TAG_REQUEST, payload);
export const filterUsersByTagSuccess = (payload: { Users: UserInterface[] }) =>
  action(AttendanceTypes.FILTER_USERS_BY_TAG_SUCCESS, payload);
export const filterUsersByTagFailure = () =>
  action(AttendanceTypes.FILTER_USERS_BY_TAG_FAILURE);

// Filter tags by name
export const filterTagByNameRequest = (payload: { tag: string }) =>
  action(AttendanceTypes.FILTER_TAG_BY_NAME_REQUEST, payload);
export const filterTagByNameSuccess = (payload: { tags: TagInterface[] }) =>
  action(AttendanceTypes.FILTER_TAG_BY_NAME_SUCCESS, payload);
export const filterTagByNameFailure = () =>
  action(AttendanceTypes.FILTER_TAG_BY_NAME_FAILURE);

// Has More
export const loadHasMoreOpenedUsersSuccess = () =>
  action(AttendanceTypes.LOAD_HAS_MORE_OPENED_USERS_SUCCESS);

// Has Closed More
export const loadHasMoreClosedUsersSuccess = () =>
  action(AttendanceTypes.LOAD_HAS_MORE_CLOSED_USERS_SUCCESS);

// Has Chatbot More
export const loadHasMoreChatbotUsersSuccess = () =>
  action(AttendanceTypes.LOAD_HAS_MORE_CHATBOT_USERS_SUCCESS);

// Load New Message
export const loadNewMessageRequest = (payload: object) =>
  action(AttendanceTypes.LOAD_NEW_MESSAGE_REQUEST, payload);
export const loadNewMessageSuccess = (payload: {
  message: UserMessageInteface;
}) => action(AttendanceTypes.LOAD_NEW_MESSAGE_SUCCESS, payload);
export const loadNewMessageFailure = () =>
  action(AttendanceTypes.LOAD_NEW_MESSAGE_FAILURE);

// Load New User
export const loadNewUserRequest = (payload: object) =>
  action(AttendanceTypes.LOAD_NEW_USER_REQUEST, payload);
export const loadNewUserSuccess = (payload: { user: AttendanceInterface }) =>
  action(AttendanceTypes.LOAD_NEW_USER_SUCCESS, payload);
export const loadNewUserFailure = () =>
  action(AttendanceTypes.LOAD_NEW_USER_FAILURE);

// Set Room
export const loadRoomSuccess = (payload: { Room: string }) =>
  action(AttendanceTypes.LOAD_ROOM_SUCCESS, payload);

// Set Conversation Status
export const loadConversationStatusSuccess = (payload: { status: number }) =>
  action(AttendanceTypes.LOAD_CONVERSATION_STATUS_SUCCESS, payload);

// Set subscribe
export const loadSubscribeSuccess = (payload: { status: boolean }) =>
  action(AttendanceTypes.LOAD_SUBSCRIBE_SUCCESS, payload);

// Set attendant Filter
export const loadAttendantConversatonLitsSuccess = (payload: {
  AttendantID: string;
}) => action(AttendanceTypes.LOAD_ATTENDANT_CONVERSATION_LIST_SUCCESS, payload);

// Set Opened Dialogue Status
export const setOpenedDialogueSuccess = (payload: {
  status: number;
  user: UserInterface;
}) => action(AttendanceTypes.SET_OPENED_STATUS_SUCCESS, payload);

// Set Visualized Message Status
export const setVisualizedMessageStatusSuccess = (payload: {
  Room: string;
  messageStatus: any[];
}) => action(AttendanceTypes.SET_VISUALIZED_MESSAGE_STATUS_SUCCESS, payload);

// Set Visualized Message Status
export const setAttendantMessageStatusSuccess = (payload: {
  Room: string;
  messageData: AttendanceInterface;
}) => action(AttendanceTypes.SET_ATTENDANT_MESSAGE_STATUS_SUCCESS, payload);

// Set Opened Dialogue Status
export const setClosedDialogueSuccess = (payload: {
  status: number;
  user: UserInterface;
}) => action(AttendanceTypes.SET_CLOSED_STATUS_SUCCESS, payload);

// Set Attendant Conversation Owner
export const updateUserRequest = (payload: {
  Room: string;
  attendantId: string;
  username: string;
  conversationStatus: number;
}) => action(AttendanceTypes.UPDATE_USER_REQUEST, payload);
export const updateUserSuccess = (payload: {
  Room: string;
  attendantId: string;
  username: string;
}) => action(AttendanceTypes.UPDATE_USER_SUCCESS, payload);
export const updateUserFailure = () =>
  action(AttendanceTypes.UPDATE_USER_FAILURE);

// Set Typing Status
export const setTypingStatusRequest = (payload: object) =>
  action(AttendanceTypes.SET_TYPING_STATUS_REQUEST, payload);
export const setTypingStatusSuccess = (payload: {
  typingStatus: boolean;
  Room: string;
}) => action(AttendanceTypes.SET_TYPING_STATUS_SUCCESS, payload);
export const setTypingStatusFailure = () =>
  action(AttendanceTypes.SET_TYPING_STATUS_FAILURE);

// Get Tag
export const getTagRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.GET_TAG_REQUEST, payload);
export const getTagSuccess = (payload: { Tag: TagsInterface }) =>
  action(AttendanceTypes.GET_TAG_SUCCESS, payload);
export const getTagFailure = () => action(AttendanceTypes.GET_TAG_FAILURE);

// List All Tags
export const listTagsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(AttendanceTypes.LIST_TAGS_REQUEST, payload);
export const listTagsSuccess = (payload: {
  Tags: TagsInterface[];
  totalCount: number;
}) => action(AttendanceTypes.LIST_TAGS_SUCCESS, payload);
export const listTagsFailure = () => action(AttendanceTypes.LIST_TAGS_FAILURE);

// Create Tag
export const createTagsRequest = (payload: { Tag: string }) =>
  action(AttendanceTypes.CREATE_TAGS_REQUEST, payload);
export const createTagsSuccess = (payload: { Tag: TagsInterface }) =>
  action(AttendanceTypes.CREATE_TAGS_SUCCESS, payload);
export const createTagsFailure = () =>
  action(AttendanceTypes.CREATE_TAGS_FAILURE);

export const filterTagsRequest = (payload: object) =>
  action(AttendanceTypes.FILTER_TAGS_REQUEST, payload);
export const filterTagsSuccess = (payload: {
  Tags: TagsInterface[];
  totalCount: number;
}) => action(AttendanceTypes.FILTER_TAGS_SUCCESS, payload);
export const filterTagsFailure = () =>
  action(AttendanceTypes.FILTER_TAGS_FAILURE);

// Update Tag
export const updateTagsRequest = (payload: {
  ID: string;
  Tag: string;
  createdAt: number;
}) => action(AttendanceTypes.UPDATE_TAGS_REQUEST, payload);
export const updateTagsSuccess = (payload: { ID: string; Tag: string }) =>
  action(AttendanceTypes.UPDATE_TAGS_SUCCESS, payload);
export const updateTagsFailure = () =>
  action(AttendanceTypes.UPDATE_TAGS_FAILURE);

// Delete Tag
export const deleteTagsRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_TAGS_REQUEST, payload);
export const deleteTagsSuccess = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_TAGS_SUCCESS, payload);
export const deleteTagsFailure = () =>
  action(AttendanceTypes.DELETE_TAGS_FAILURE);

// Get User Tags
export const getUserTagsRequest = (payload: {
  Room: string;
  conversationStatus: number;
}) => action(AttendanceTypes.GET_USER_TAGS_REQUEST, payload);
export const getUserTagsSuccess = (payload: { Tags: TagInterface[] }) =>
  action(AttendanceTypes.GET_USER_TAGS_SUCCESS, payload);
export const getUserTagsFailure = () =>
  action(AttendanceTypes.GET_USER_TAGS_FAILURE);

// Delete User Tags
export const deleteUserTagsRequest = (payload: {
  Room: string;
  ID: string;
  conversationStatus: number;
}) => action(AttendanceTypes.DELETE_USER_TAGS_REQUEST, payload);
export const deleteUserTagsSuccess = (payload: { Room: string; ID: string }) =>
  action(AttendanceTypes.DELETE_USER_TAGS_SUCCESS, payload);
export const deleteUserTagsFailure = () =>
  action(AttendanceTypes.DELETE_USER_TAGS_FAILURE);

// Create User Tag
export const createUserTagsRequest = (payload: {
  Room: string;
  Tag: string;
  ID: string;
  conversationStatus: number;
}) => action(AttendanceTypes.CREATE_USER_TAGS_REQUEST, payload);
export const createUserTagsSuccess = (payload: {
  Room: string;
  Tag: string;
  ID: string;
}) => action(AttendanceTypes.CREATE_USER_TAGS_SUCCESS, payload);
export const createUserTagsFailure = () =>
  action(AttendanceTypes.CREATE_USER_TAGS_FAILURE);

// Create Message Tag
export const createMessageTagRequest = (payload: {
  messageID: number;
  Room: string;
  Tag: string;
  conversationStatus: number;
}) => action(AttendanceTypes.CREATE_MESSAGE_TAG_REQUEST, payload);
export const createMessageTagSuccess = (payload: {
  messageID: number;
  Room: string;
  Tag: string;
  ID: string;
}) => action(AttendanceTypes.CREATE_MESSAGE_TAG_SUCCESS, payload);
export const createMessageTagFailure = () =>
  action(AttendanceTypes.CREATE_MESSAGE_TAG_FAILURE);

// Delete Message Tag
export const deleteMessageTagRequest = (payload: {
  messageID: number;
  Room: string;
  ID: string;
  conversationStatus: number;
}) => action(AttendanceTypes.DELETE_MESSAGE_TAG_REQUEST, payload);
export const deleteMessageTagSuccess = (payload: {
  messageID: number;
  Room: string;
  ID: string;
}) => action(AttendanceTypes.DELETE_MESSAGE_TAG_SUCCESS, payload);
export const deleteMessageTagFailure = () =>
  action(AttendanceTypes.DELETE_MESSAGE_TAG_FAILURE);

// Get Qualification
export const getQualificationRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.GET_QUALIFICATION_REQUEST, payload);
export const getQualificationSuccess = (payload: { Data: object }) =>
  action(AttendanceTypes.GET_QUALIFICATION_SUCCESS, payload);
export const getQualificationFailure = () =>
  action(AttendanceTypes.GET_QUALIFICATION_FAILURE);

// Create Qualification
export const createQualificationRequest = (payload: {
  ID: string;
  key: string;
  value: string;
}) => action(AttendanceTypes.CREATE_QUALIFICATION_REQUEST, payload);
export const createQualificationSuccess = (payload: any) =>
  action(AttendanceTypes.CREATE_QUALIFICATION_SUCCESS, payload);
export const createQualificationFailure = () =>
  action(AttendanceTypes.CREATE_QUALIFICATION_FAILURE);

// List All Replies
export const listRepliesRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(AttendanceTypes.LIST_REPLY_REQUEST, payload);
export const listRepliesSuccess = (payload: {
  Replies: ReplyInterface[];
  totalCount: number;
}) => action(AttendanceTypes.LIST_REPLY_SUCCESS, payload);
export const listRepliesFailure = () =>
  action(AttendanceTypes.LIST_REPLY_FAILURE);

// Get Reply
export const getReplyRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.GET_REPLY_REQUEST, payload);
export const getReplySuccess = (payload: { Reply: ReplyInterface }) =>
  action(AttendanceTypes.GET_REPLY_SUCCESS, payload);
export const getReplyFailure = () => action(AttendanceTypes.GET_REPLY_FAILURE);

// Filter Replies
export const filterRepliesRequest = (payload: object) =>
  action(AttendanceTypes.FILTER_REPLY_REQUEST, payload);
export const filterRepliesSuccess = (payload: {
  Replies: ReplyInterface[];
  totalCount: number;
}) => action(AttendanceTypes.FILTER_REPLY_SUCCESS, payload);
export const filterRepliesFailure = () =>
  action(AttendanceTypes.FILTER_REPLY_FAILURE);

// Create Reply
export const createReplyRequest = (payload: {
  Title: string;
  Description: string;
}) => action(AttendanceTypes.CREATE_REPLY_REQUEST, payload);
export const createReplySuccess = (payload: { Reply: ReplyInterface }) =>
  action(AttendanceTypes.CREATE_REPLY_SUCCESS, payload);
export const createReplyFailure = () =>
  action(AttendanceTypes.CREATE_REPLY_FAILURE);

// Update Reply
export const updateReplyRequest = (payload: { Reply: ReplyInterface }) =>
  action(AttendanceTypes.UPDATE_REPLY_REQUEST, payload);
export const updateReplySuccess = (payload: { Reply: ReplyInterface }) =>
  action(AttendanceTypes.UPDATE_REPLY_SUCCESS, payload);
export const updateReplyFailure = () =>
  action(AttendanceTypes.UPDATE_REPLY_FAILURE);

// Delete Reply
export const deleteReplyRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_REPLY_REQUEST, payload);
export const deleteReplySuccess = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_REPLY_SUCCESS, payload);
export const deleteReplyFailure = () =>
  action(AttendanceTypes.DELETE_REPLY_FAILURE);

// Get File
export const getFileRequest = (payload: { fileName: string }) =>
  action(AttendanceTypes.GET_FILE_REQUEST, payload);

// Create File
export const createFileRequest = (payload: {
  fileName: string;
  File: string;
}) => action(AttendanceTypes.CREATE_FILE_REQUEST, payload);

// Get current user picture
export const getCurrentUserPictureRequest = (payload: { Room: string }) =>
  action(AttendanceTypes.GET_CURRENT_USER_PICTURE_REQUEST, payload);
export const getCurrentUserPictureSuccess = (payload: { URL: string }) =>
  action(AttendanceTypes.GET_CURRENT_USER_PICTURE_SUCCESS, payload);
export const getCurrentUserPictureFailure = () =>
  action(AttendanceTypes.GET_CURRENT_USER_PICTURE_FAILURE);

// Get user picturre
export const getUserPictureRequest = (payload: { Room: string }) =>
  action(AttendanceTypes.GET_USER_PICTURE_REQUEST, payload);
export const getUserPictureSuccess = (payload: { Room: string; URL: string }) =>
  action(AttendanceTypes.GET_USER_PICTURE_SUCCESS, payload);
export const getUserPictureFailure = () =>
  action(AttendanceTypes.GET_USER_PICTURE_FAILURE);

// Get attendant picture
export const getAttendantPictureRequest = (payload: { Room: string }) =>
  action(AttendanceTypes.GET_ATTENDANT_PICTURE_REQUEST, payload);
export const getAttendantPictureSuccess = (payload: {
  Room: string;
  URL: string;
}) => action(AttendanceTypes.GET_ATTENDANT_PICTURE_SUCCESS, payload);
export const getAttendantPictureFailure = () =>
  action(AttendanceTypes.GET_ATTENDANT_PICTURE_FAILURE);

// Create attendant picture
export const createAttendantPictureRequest = (payload: {
  fileName: string;
  File: string;
}) => action(AttendanceTypes.CREATE_ATTENDANT_PICTURE_REQUEST, payload);

// List Office hours
export const listOfficeHoursRequest = (payload: object) =>
  action(AttendanceTypes.LIST_OFFICE_HOURS_REQUEST, payload);
export const listOfficeHoursSuccess = (payload: {
  OfficeHours: OfficeHoursInterface[];
  totalCount: number;
}) => action(AttendanceTypes.LIST_OFFICE_HOURS_SUCCESS, payload);
export const listOfficeHoursFailure = () =>
  action(AttendanceTypes.LIST_REPLY_FAILURE);

// Get Office hours
export const getOfficeHoursRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.GET_OFFICE_HOURS_REQUEST, payload);
export const getOfficeHoursSuccess = (payload: {
  OfficeHour: OfficeHoursInterface;
}) => action(AttendanceTypes.GET_OFFICE_HOURS_SUCCESS, payload);
export const getOfficeHoursFailure = () =>
  action(AttendanceTypes.GET_OFFICE_HOURS_FAILURE);

// Create Office hours
export const createOfficeHoursRequest = (payload: {
  OfficeHour: OfficeHoursInterface;
}) => action(AttendanceTypes.CREATE_OFFICE_HOURS_REQUEST, payload);
export const createOfficeHoursSuccess = (payload: {
  OfficeHour: OfficeHoursInterface;
}) => action(AttendanceTypes.CREATE_OFFICE_HOURS_SUCCESS, payload);
export const createOfficeHoursFailure = () =>
  action(AttendanceTypes.CREATE_OFFICE_HOURS_FAILURE);

// Update Office hours
export const updateOfficeHoursRequest = (payload: {
  OfficeHour: OfficeHoursInterface;
}) => action(AttendanceTypes.UPDATE_OFFICE_HOURS_REQUEST, payload);
export const updateOfficeHoursSuccess = (payload: {
  OfficeHour: OfficeHoursInterface;
}) => action(AttendanceTypes.UPDATE_OFFICE_HOURS_SUCCESS, payload);
export const updateOfficeHoursFailure = () =>
  action(AttendanceTypes.UPDATE_OFFICE_HOURS_FAILURE);

// Delete Office hours
export const deleteOfficeHoursRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_OFFICE_HOURS_REQUEST, payload);
export const deleteOfficeHoursSuccess = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_OFFICE_HOURS_SUCCESS, payload);
export const deleteOfficeHoursFailure = () =>
  action(AttendanceTypes.DELETE_OFFICE_HOURS_FAILURE);

// List Attendants
export const listAttendantsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(AttendanceTypes.LIST_ATTENDANTS_REQUEST, payload);
export const listAttendantsSuccess = (payload: {
  Attendants: AttendantInterface[];
  totalCount: number;
}) => action(AttendanceTypes.LIST_ATTENDANTS_SUCCESS, payload);
export const listAttendantsFailure = () =>
  action(AttendanceTypes.LIST_ATTENDANTS_FAILURE);

// Get Attendants
export const getAttendantRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.GET_ATTENDANTS_REQUEST, payload);
export const getAttendantSuccess = (payload: {
  Attendant: AttendantInterface;
}) => action(AttendanceTypes.GET_ATTENDANTS_SUCCESS, payload);
export const getAttendantFailure = () =>
  action(AttendanceTypes.GET_ATTENDANTS_FAILURE);

// Filter Attendants
export const filterAttendantsRequest = (payload: object) =>
  action(AttendanceTypes.FILTER_ATTENDANTS_REQUEST, payload);
export const filterAttendantsSuccess = (payload: {
  Attendants: AttendantInterface[];
  totalCount: number;
}) => action(AttendanceTypes.FILTER_ATTENDANTS_SUCCESS, payload);
export const filterAttendantsFailure = () =>
  action(AttendanceTypes.FILTER_ATTENDANTS_FAILURE);

// Create Attendants
export const createAttendantRequest = (payload: {
  Name: string;
  Email: string;
  Modules: string[];
}) => action(AttendanceTypes.CREATE_ATTENDANTS_REQUEST, payload);
export const createAttendantSuccess = (payload: {
  Attendant: AttendantInterface;
}) => action(AttendanceTypes.CREATE_ATTENDANTS_SUCCESS, payload);
export const createAttendantFailure = () =>
  action(AttendanceTypes.CREATE_ATTENDANTS_FAILURE);

// Update Attendants
export const updateAttendantRequest = (payload: {
  Attendant: AttendantInterface;
}) => action(AttendanceTypes.UPDATE_ATTENDANTS_REQUEST, payload);
export const updateAttendantSuccess = (payload: {
  Attendant: AttendantInterface;
}) => action(AttendanceTypes.UPDATE_ATTENDANTS_SUCCESS, payload);
export const updateAttendantFailure = () =>
  action(AttendanceTypes.UPDATE_ATTENDANTS_FAILURE);

// Delete Attendants
export const deleteAttendantRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_ATTENDANTS_REQUEST, payload);
export const deleteAttendantSuccess = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_ATTENDANTS_SUCCESS, payload);
export const deleteAttendantFailure = () =>
  action(AttendanceTypes.DELETE_ATTENDANTS_FAILURE);

// Get Current Attendant
export const getCurrentAttendantRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.GET_CURRENT_ATTENDANT_REQUEST, payload);
export const getCurrentAttendantSuccess = (payload: {
  Attendant: AttendantInterface;
}) => action(AttendanceTypes.GET_CURRENT_ATTENDANT_SUCCESS, payload);
export const getCurrentAttendantFailure = () =>
  action(AttendanceTypes.GET_CURRENT_ATTENDANT_FAILURE);

// Get Token
export const getTokenRequest = () => action(AttendanceTypes.GET_TOKEN_REQUEST);
export const getTokenSuccess = (payload: { Token: string }) =>
  action(AttendanceTypes.GET_TOKEN_SUCCESS, payload);
export const getTokenFailure = () => action(AttendanceTypes.GET_TOKEN_FAILURE);

// Create Token
export const createTokenRequest = () =>
  action(AttendanceTypes.CREATE_TOKEN_REQUEST);
export const createTokenSuccess = (payload: { Token: string }) =>
  action(AttendanceTypes.CREATE_TOKEN_SUCCESS, payload);
export const createTokenFailure = () =>
  action(AttendanceTypes.CREATE_TOKEN_FAILURE);

// Delete Token
export const deleteTokenRequest = () =>
  action(AttendanceTypes.DELETE_TOKEN_REQUEST);
export const deleteTokenSuccess = () =>
  action(AttendanceTypes.DELETE_TOKEN_SUCCESS);
export const deleteTokenFailure = () =>
  action(AttendanceTypes.DELETE_TOKEN_FAILURE);

// List Webhooks
export const listWebhookRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(AttendanceTypes.LIST_WEBHOOK_REQUEST, payload);
export const listWebhookSuccess = (payload: {
  webhookList: WebhookInterface[];
}) => action(AttendanceTypes.LIST_WEBHOOK_SUCCESS, payload);
export const listWebhookFailure = () =>
  action(AttendanceTypes.LIST_WEBHOOK_FAILURE);

// Filter Webhooks
export const filterWebhookRequest = (payload: object) =>
  action(AttendanceTypes.FILTER_WEBHOOK_REQUEST, payload);
export const filterWebhookSuccess = (payload: {
  webhookList: WebhookInterface[];
}) => action(AttendanceTypes.FILTER_WEBHOOK_SUCCESS, payload);
export const filterWebhookFailure = () =>
  action(AttendanceTypes.FILTER_WEBHOOK_FAILURE);

// Create Webhooks
export const createWebhookRequest = (payload: { type: string; url: string }) =>
  action(AttendanceTypes.CREATE_WEBHOOK_REQUEST, payload);
export const createWebhookSuccess = (payload: {
  webhookData: WebhookInterface;
}) => action(AttendanceTypes.CREATE_WEBHOOK_SUCCESS, payload);
export const createWebhookFailure = () =>
  action(AttendanceTypes.CREATE_WEBHOOK_FAILURE);

// Update Webhooks
export const updateWebhookRequest = (payload: {
  webhookData: WebhookInterface;
}) => action(AttendanceTypes.UPDATE_WEBHOOK_REQUEST, payload);
export const updateWebhookSuccess = (payload: {
  webhookData: WebhookInterface;
}) => action(AttendanceTypes.UPDATE_WEBHOOK_SUCCESS, payload);
export const updateWebhookFailure = () =>
  action(AttendanceTypes.UPDATE_WEBHOOK_FAILURE);

// Delete Webhooks
export const deleteWebhookRequest = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_WEBHOOK_REQUEST, payload);
export const deleteWebhookSuccess = (payload: { ID: string }) =>
  action(AttendanceTypes.DELETE_WEBHOOK_SUCCESS, payload);
export const deleteWebhookFailure = () =>
  action(AttendanceTypes.DELETE_WEBHOOK_FAILURE);

// Get HeatMap Report
export const getHeatMapRequest = (payload: {
  startDate: number;
  endDate: number;
}) => action(AttendanceTypes.GET_HEATMAP_REQUEST, payload);
export const getHeatMapSuccess = (payload: { heatmapData: HeatmapInterface }) =>
  action(AttendanceTypes.GET_HEATMAP_SUCCESS, payload);
export const getHeatMapFailure = () =>
  action(AttendanceTypes.GET_HEATMAP_FAILURE);

// Get Count Word Report
export const getWordCountRequest = (payload: {
  startDate: number;
  endDate: number;
}) => action(AttendanceTypes.GET_WORDCOUNT_REQUEST, payload);
export const getWordCountSuccess = (payload: {
  wordCountData: WordCountInterface[];
}) => action(AttendanceTypes.GET_WORDCOUNT_SUCCESS, payload);
export const getWordCountFailure = () =>
  action(AttendanceTypes.GET_WORDCOUNT_FAILURE);

// Get Tags Report
export const getTagsLinesChartRequest = (payload: {
  startDate: number;
  endDate: number;
  type: number;
}) => action(AttendanceTypes.GET_TAGS_LINES_CHART_REQUEST, payload);
export const getTagsLinesChartSuccess = (payload: {
  TagsLinesChartData: any[];
}) => action(AttendanceTypes.GET_TAGS_LINES_CHART_SUCCESS, payload);
export const getTagsLinesChartFailure = () =>
  action(AttendanceTypes.GET_TAGS_LINES_CHART_FAILURE);

// Get Rating Report
export const getRatingChartRequest = (payload: {
  startDate: number;
  endDate: number;
  attendantsId: any[];
}) => action(AttendanceTypes.GET_RATING_CHART_REQUEST, payload);
export const getRatingChartSuccess = (payload: { RatingChartData: any[] }) =>
  action(AttendanceTypes.GET_RATING_CHART_SUCCESS, payload);
export const getRatingChartFailure = () =>
  action(AttendanceTypes.GET_RATING_CHART_FAILURE);

// Get Conversation Close Report
export const getCloseConversationChartRequest = (payload: {
  startDate: number;
  endDate: number;
  attendantsId: any[];
}) => action(AttendanceTypes.GET_CLOSE_CONVERSATION_CHART_REQUEST, payload);
export const getCloseConversationChartSuccess = (payload: {
  CloseConversationChartData: AttendantChartInterface;
}) => action(AttendanceTypes.GET_CLOSE_CONVERSATION_CHART_SUCCESS, payload);
export const getCloseConversationChartFailure = () =>
  action(AttendanceTypes.GET_CLOSE_CONVERSATION_CHART_FAILURE);

// Get First Reply Report
export const getFirstReplyChartRequest = (payload: {
  startDate: number;
  endDate: number;
  attendantsId: any[];
}) => action(AttendanceTypes.GET_FIRST_REPLY_CHART_REQUEST, payload);
export const getFirstReplyChartSuccess = (payload: {
  FirstReplyChartData: AttendantChartInterface;
}) => action(AttendanceTypes.GET_FIRST_REPLY_CHART_SUCCESS, payload);
export const getFirstReplyChartFailure = () =>
  action(AttendanceTypes.GET_FIRST_REPLY_CHART_FAILURE);

// Get Conversaiton Reply Report
export const getConversationReplyChartRequest = (payload: {
  startDate: number;
  endDate: number;
}) => action(AttendanceTypes.GET_CONVERSATION_REPLY_CHART_REQUEST, payload);
export const getConversationReplyChartSuccess = (payload: {
  ConversationReplyChartData: ConversationReplyInterface;
}) => action(AttendanceTypes.GET_CONVERSATION_REPLY_CHART_SUCCESS, payload);
export const getConversationReplyChartFailure = () =>
  action(AttendanceTypes.GET_CONVERSATION_REPLY_CHART_FAILURE);

// Get Human and Chatbot Report
export const getHumanAndChatbotChartRequest = (payload: {
  startDate: number;
  endDate: number;
}) =>
  action(AttendanceTypes.GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_REQUEST, payload);
export const getHumanAndChatbotChartSuccess = (payload: {
  humanAndChatbotChartData: HumanAndChatbotChartDataInterface;
}) =>
  action(AttendanceTypes.GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_SUCCESS, payload);
export const getHumanAndChatbotChartFailure = () =>
  action(AttendanceTypes.GET_HUMAN_AND_CHATBOT_MESSAGES_CHART_FAILURE);

// Get First Reply Scatter Report
export const getFirstReplyScatterChartRequest = (payload: {
  startDate: number;
  endDate: number;
}) => action(AttendanceTypes.GET_FIRST_REPLY_SCATTER_CHART_REQUEST, payload);
export const getFirstReplyScatterChartSuccess = (payload: {
  FirstReplyScatterChartData: number[];
}) => action(AttendanceTypes.GET_FIRST_REPLY_SCATTER_CHART_SUCCESS, payload);
export const getFirstReplyScatterChartFailure = () =>
  action(AttendanceTypes.GET_FIRST_REPLY_SCATTER_CHART_FAILURE);

// Search Message
export const loadSearchMessageIdSuccess = (payload: { messageId: number }) =>
  action(AttendanceTypes.LOAD_SEARCH_MESSAGE_ID_SUCCESS, payload);
// Get Attendance History
export const getAttendanceHistoryRequest = (payload: {
  room: string;
  conversationStatus: number;
}) => action(AttendanceTypes.GET_ATTENDANCE_HISTORY_REQUEST, payload);

export const getAttendanceHistorySuccess = (payload: {
  attendanceHistory: AttendanceHistoryInterface[];
}) => action(AttendanceTypes.GET_ATTENDANCE_HISTORY_SUCCESS, payload);

export const getAttendanceHistoryFailure = (payload: { statusCode?: number }) =>
  action(AttendanceTypes.GET_ATTENDANCE_HISTORY_FAILURE, payload);

// List ratings
export const listRatingRequest = (payload: {
  startDate: number;
  endDate: number;
  attendantId?: string;
  ratingId?: string;
  createdAt?: number;
  limit?: number;
  scanForward: string;
}) => action(AttendanceTypes.LIST_RATING_REQUEST, payload);
export const listRatingSuccess = (payload: {
  ratingList: RatingListInterface[];
}) => action(AttendanceTypes.LIST_RATING_SUCCESS, payload);
export const listRatingFailure = () =>
  action(AttendanceTypes.LIST_RATING_FAILURE);

// List Number of Messages
export const listNumberOfMessagesRequest = (payload: {
  startDate: number;
  endDate: number;
}) => action(AttendanceTypes.LIST_NUMBER_OF_MESSAGES_REQUEST, payload);
export const listNumberOfMessagesSuccess = (payload: {
  numberOfMessagesList: NumberOfMessagesInterface[];
}) => action(AttendanceTypes.LIST_NUMBER_OF_MESSAGES_SUCCESS, payload);
export const listNumberOfMessagesFailure = () =>
  action(AttendanceTypes.LIST_NUMBER_OF_MESSAGES_FAILURE);

// Set attendant assignment

export const setAttendantAssignmentSuccess = (payload: {
  data: {
    room: string;

    attendantId: string;

    attendantUsername: string;

    previousAttendantId: string;

    previousAttendantUsername: string;

    isNewAttendant: boolean;
  };
}) => action(AttendanceTypes.SET_ATTENDANT_ASSIGNMENT_SUCCESS, payload);
